module.exports = __webpack_public_path__ + "static/img/default-avatar.4ab67536.png";